const insuranceViewRightDocumentTypes = [
  { id: -5, code: "WLD" },
  { id: -8, code: "WLDI" },
  { id: -11, code: "WCM" },
  { id: -12, code: "WCMI" }
];

export const getDocumentRightsByStateKey = (documentStateId, documentTypeId) => {
  return documentStateId !== undefined && documentStateId !== null
    ? `Document|${documentStateId}|${documentTypeId}`
    : `DocumentType|${documentTypeId}`;
};

export const getRightToViewInsuranceByDocumentType = documentTypeId =>
  insuranceViewRightDocumentTypes.find(x => x.id === documentTypeId) ? true : false;

export const offerSteps = {
  firstStep: { id: 0 },
  productsStep: { id: 1 },
  financialInfoStep: { id: 2 },
  clientStep: { id: 3 },
  scoringStep: { id: 4 },
  decisionStep: { id: 5 },
  insuranceStep: { id: 6 }
};

export const folderSteps = {
  generalDataStep: { id: 0 },
  exposureStep: { id: 1 },
  scoringStep: { id: 2 },
  decisionStep: { id: 3 },
  fourthStep: { id: 4 }
};

export const periodicities = [
  { id: 1, code: "Monthly", value: 1, implicit: false },
  { id: 2, code: "Quarterly", value: 3, implicit: true },
  { id: 3, code: "Semiannual", value: 6, implicit: false },
  { id: 4, code: "Yearly", value: 12, implicit: false }
];

export const getTranslationByCount = (count, singularTag, pluralTag, t) =>
  count > 1 ? `(${t(pluralTag, { count: count })})` : `(${t(singularTag, { count: count })})`;
